import React from 'react';
import { Route, Routes } from 'react-router-dom';
import BasicTables from '../../../Tables/BasicTables/index';
import DataTable from '../../../Tables/DataTable/index';
import DragAndDropTable from '../../../Tables/DnDTable/index';
import EditableTable from '../../../Tables/EditableTable/index';
import ResizableTable from '../../../Tables/ResizableTable';
import MaterialTable from '../../../Tables/MaterialTable/index';

export default () => (
  <Routes>
    <Route path="/tables/basic_tables" element={<BasicTables />} />
    <Route path="/tables/data_table" element={<DataTable />} />
    <Route path="/tables/dnd_table" element={<DragAndDropTable />} />
    <Route path="/tables/editable_table" element={<EditableTable />} />
    {/* <Route path="/tables/resizable_table" element={<ResizableTable />} /> */}
    <Route path="/tables/material_table" element={<MaterialTable />} />
    
  </Routes>
);
